<app-header></app-header>
<app-botao-chat></app-botao-chat>
<app-alert-historico-anotacoes-ocorrencias
  [showAlertAnotacoesOcorrencias]="showAlertAnotacoesOcorrencias"
  [idOcorrencia]="idOcorrencia"
  (alertAnotacoesOcorrencias)="eventoAlertAlterarEmpresaFechou($event)"
></app-alert-historico-anotacoes-ocorrencias>
<app-loading-generico
  [loadingGenerico]="loadingGenerico"
></app-loading-generico>

<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div>
        <app-breadcrumb></app-breadcrumb>
        <div class="col-titulo">
          <h1 class="titulo">
            Detalhe da Ocorrência
          </h1>
        </div>
        <div class="panel-detalhe-ocorrencia">
          <div class="row linha-detalhe-ocorrencia">
            <div class="col-lg-3">
              <span class="texto-titulo text-start">TIPO DE OCORRÊNCIA</span>
              <p class="texto-subtitulo text-start">
                {{ resources?.dsTipoOcorrencia }}
              </p>
            </div>
            <div class="col-lg-3">
              <span class="texto-titulo text-start">N° DA OCORRÊNCIA</span>
              <p class="texto-subtitulo text-start">
                {{ resources?.numeroOcorrencia }}
              </p>
            </div>
            <div class="col-lg-3">
              <span class="texto-titulo text-start">SITUAÇÃO DA OCOÊNCIA</span>
              <p class="texto-subtitulo text-start">
                {{ resources?.situacaoOcorrencia }}
              </p>
            </div>
          </div>
          <div class="row linha-detalhe-ocorrencia">
            <div class="col-lg-3">
              <span class="texto-titulo text-start">BENEFÍCIO</span>
              <p class="texto-subtitulo text-start">
                {{ resources?.dsBeneficio }}
              </p>
            </div>
            <div class="col-lg-3">
              <span class="texto-titulo text-start">CONTATO</span>
              <p class="texto-subtitulo text-start">
                {{ resources?.nomeContato }}
              </p>
            </div>
            <div class="col-lg-3">
              <span class="texto-titulo text-start">Nº DO PEDIDO</span>
              <p class="texto-subtitulo text-start">
                {{ resources?.numeroPedido }}
              </p>
            </div>
          </div>
          <div class="row linha-detalhe-ocorrencia">
            <div class="col-lg-3">
              <span class="texto-titulo text-start">RESUMO DA OCORRÊNCIA</span>
              <p class="texto-subtitulo text-start">
                {{ resources?.dsResumoOcorrencia }}
              </p>
            </div>
            <div class="col-lg-3">
              <span class="texto-titulo text-start">EMISSÃO</span>
              <p class="texto-subtitulo text-start">
                {{ $safeNavigationMigration(resources?.dataEmissao) | date : "dd/MM/yyy , H:mm":'GMT' }}
              </p>
            </div>
            <div class="col-lg-3">
              <span class="texto-titulo text-start">ENCERRADA</span>
              <p class="texto-subtitulo text-start">
                {{ $safeNavigationMigration(resources?.dataEncerrada) | date : "dd/MM/yyy , H:mm":'GMT' }}
              </p>
            </div>
          </div>
          <div class="row linha-detalhe-ocorrencia">
            <div class="col-lg-12">
              <span class="texto-titulo text-start">ACESSAR</span>
              <div class="button-content" style="margin-left: 2px;">
                <div class="painel-botoes-arquivos">
                  <button (click)="abrirFecharArquivosAnexados()"
                    class="btn botao-outline"
                    style="width: 186; height: 34px;">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 33 33"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.32096 7.25423C7.32096 5.78147 8.51487 4.58756 9.98763 4.58756H16.6543V8.58756C16.6543 11.5331 19.0421 13.9209 21.9876 13.9209H25.9876V25.9209C25.9876 27.3937 24.7937 28.5876 23.321 28.5876H9.98763C8.51487 28.5876 7.32096 27.3937 7.32096 25.9209V7.25423ZM25.9438 11.2542C25.836 10.6673 25.5331 10.1282 25.077 9.7291L19.955 5.24736C19.7628 5.0792 19.5491 4.94088 19.321 4.83509V8.58756C19.321 10.0603 20.5149 11.2542 21.9876 11.2542H25.9438ZM9.98763 1.9209C7.04211 1.9209 4.6543 4.30871 4.6543 7.25423V25.9209C4.6543 28.8664 7.04211 31.2542 9.98763 31.2542H23.321C26.2665 31.2542 28.6543 28.8664 28.6543 25.9209V11.736C28.6543 10.198 27.9904 8.73496 26.833 7.72223L21.711 3.24049C20.7388 2.3898 19.4908 1.9209 18.199 1.9209H9.98763Z"
                        fill="#008060"/>
                    </svg>
                    ARQUIVOS ANEXADOS
                  </button>
                </div>
                <div class="painel-botoes-arquivos">
                  <button
                    class="btn botao-outline w-auto" (click)='alertAnotacoesOcorrencias()'
                    style="width: 217px; height: 34px">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 33 33"
                      fill="none">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.3208 13.3604C7.3208 12.6241 7.91775 12.0271 8.65413 12.0271H24.6541C25.3905 12.0271 25.9875 12.6241 25.9875 13.3604C25.9875 14.0968 25.3905 14.6938 24.6541 14.6938H8.65413C7.91775 14.6938 7.3208 14.0968 7.3208 13.3604Z"
                        fill="#008060"/>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.3208 8.02718C7.3208 7.2908 7.91775 6.69385 8.65413 6.69385H24.6541C25.3905 6.69385 25.9875 7.2908 25.9875 8.02718C25.9875 8.76356 25.3905 9.36051 24.6541 9.36051H8.65413C7.91775 9.36051 7.3208 8.76356 7.3208 8.02718Z"
                        fill="#008060"/>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.3208 18.6937C7.3208 17.9573 7.91775 17.3604 8.65413 17.3604H24.6541C25.3905 17.3604 25.9875 17.9573 25.9875 18.6937C25.9875 19.4301 25.3905 20.027 24.6541 20.027H8.65413C7.91775 20.027 7.3208 19.4301 7.3208 18.6937Z"
                        fill="#008060"/>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.3208 24.0272C7.3208 23.2908 7.91775 22.6938 8.65413 22.6938H24.6541C25.3905 22.6938 25.9875 23.2908 25.9875 24.0272C25.9875 24.7636 25.3905 25.3605 24.6541 25.3605H8.65413C7.91775 25.3605 7.3208 24.7636 7.3208 24.0272Z"
                        fill="#008060"/>
                    </svg>
                    HISTÓRICO DE ANOTAÇÕES
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="painel-observacao">
          <div class="col-lg-12 remove-espacamento-esquerda">
            <span class="texto-titulo text-start">OBSERVAÇÃO</span>
            <p class="texto-subtitulo ">{{resources?.dsObservacoes}}</p>
          </div>
        </div>
        <div class="painel-botoes">
          <button class="btn botao-outline botao-voltar" routerLink="/gerenciar-ocorrencias">
            <svg width="20" height="20" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M21.5968 7.46596C21.0761 6.94526 20.2319 6.94526 19.7112 7.46596L11.7112 15.466C11.1905 15.9867 11.1905 16.8309 11.7112 17.3516L19.7112 25.3516C20.2319 25.8723 21.0761 25.8723 21.5968 25.3516C22.1175 24.8309 22.1175 23.9867 21.5968 23.466L14.5396 16.4088L21.5968 9.35158C22.1175 8.83088 22.1175 7.98666 21.5968 7.46596Z" fill="#008060"/>
              </svg>
              VOLTAR
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-alert-arquivos-anexados
    [arquivosAnexados]="$safeNavigationMigration(resources?.nomesArquivos)"
    [isShowArquivosAnexados]="isShowArquivosAnexados"
    (abrirFecharEmitter)="abrirFecharArquivosAnexados()">
</app-alert-arquivos-anexados>
<app-footer></app-footer>
